import { z } from 'zod';

import { LocationIdSchema, PlaceIdSchema } from '@brightlocal/shared';

export const addLocationPromptsSearchSchema = z.object({
  locationId: LocationIdSchema,
  placeId: PlaceIdSchema
});

export type AddLocationPromptsSearch = z.infer<typeof addLocationPromptsSearchSchema>;
